import { z } from 'zod';

export enum CustomFieldType {
  ENUM = 'enum',
  STRING = 'string',
  DATE = 'date',
}

export const allowedValueSchema = z.object({ key: z.string(), label: z.string() });

const configSchema = z.object({ key: z.string(), strategy: z.string() });
const baseFieldSchema = z.object({
  name: z.string(),
  label: z.string(),
  required: z.boolean().optional(),
  showInDashboard: z.boolean().optional(),
  showInReports: z.boolean().optional(),
  validation: z.string().optional(),
  entity: z.string().optional(),
});

const enumFieldSchema = baseFieldSchema.extend({
  type: z.literal('enum'),
  allowedValues: z.array(allowedValueSchema),
  config: z.array(configSchema).optional(),
});
const stringFieldSchema = baseFieldSchema.extend({ type: z.literal('string') });
const dateFieldSchema = baseFieldSchema.extend({ type: z.literal('date'), format: z.string().optional() });

export const customFieldSchema = z.discriminatedUnion('type', [enumFieldSchema, stringFieldSchema, dateFieldSchema]);
export type TCustomField = z.infer<typeof customFieldSchema>;
